import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import DiariasService from '../../../../services/diarias-auth';
import Diaria from './diaria';


const ListarDiarias = () => {


    const [diarias, setDiarias] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [diaria, setDiaria] = useState("");


    async function fetchDiarias() {
        const response = await DiariasService.listar();
        if (response.data.length >= 1) {
            setDiarias(response.data)
            setVazio(false)
        } else {
            setDiarias([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setDiaria(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Diária da tabela?')) {
            await DiariasService.deletar(id)
            alert("Diária deletada da tabela com sucesso!")
            fetchDiarias();
        }
    }

    useEffect(() => {
        fetchDiarias();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/diarias/editar/${diaria}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setDiarias={setDiarias}
                        setVazio={setVazio}
                        fetchDiarias={fetchDiarias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {diarias.map((diaria, index) =>
                                <Diaria
                                    fetchDiarias={fetchDiarias}
                                    diaria={diaria}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarDiarias;